import { render } from "./NextProjectTwo.vue?vue&type=template&id=24922aa6"
import script from "./NextProjectTwo.vue?vue&type=script&lang=js"
export * from "./NextProjectTwo.vue?vue&type=script&lang=js"

import "./NextProjectTwo.vue?vue&type=style&index=0&id=24922aa6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__